import styled, { breakpoints } from '../../../styles/theme';
import { CheckoutStepWizardStyled } from '../CheckoutStepWizardStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const CheckoutStepWizardAC = styled(CheckoutStepWizardStyled)`
    .progressWrapper {
        @media screen and (max-width: ${breakpoints.sm}px) {
            margin-top: ${rem('56px')};
            .progressBlock .progressCar {
                display: block;
            }
        }
    }
`;
